const API_URL = process.env.REACT_APP_BACKEND_URL;

async function post(path, payload) {
  const response = await fetch(`${API_URL}/api/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = Array.isArray(data.detail) ? data.detail[0]?.msg : data.detail;
    throw new Error(typeof detail === "string" ? detail : `Request failed with ${response.status}`);
  }
  return data;
}

export function submitFreeWeekLead(form) {
  return post("leads", form);
}

export function submitAppointment(appointment) {
  return post("appointments", appointment);
}
